export default "__VITE_ASSET__9aKsW1WK__"